/**
 * Normaliza teléfono / twilio de prospecto al formato usuario de mensajes Twilio.
 */
export function normalizarUsuarioTwilio(twilio, telefono) {
  const raw = String(twilio || telefono || '').trim()
  if (!raw) return ''
  if (raw.startsWith('whatsapp:')) return raw

  const digitos = raw.replace(/\D/g, '')
  if (!digitos) return ''

  const ultimos10 = digitos.length >= 10 ? digitos.slice(-10) : digitos
  if (ultimos10.length === 10) return 'whatsapp:+521' + ultimos10
  if (digitos.startsWith('521')) return 'whatsapp:+' + digitos
  if (digitos.startsWith('52')) return 'whatsapp:+' + digitos

  return 'whatsapp:+521' + ultimos10
}

export function tieneContactoTwilio(prospecto = {}) {
  return !!(prospecto.twilio || prospecto.telefono)
}
